import { YooKassaPaymentWithEmail } from './YooKassaPaymentWithEmail';
import { YooKassaSuccessPayment } from './YooKassaSuccessPayment';

export { YooKassaSuccessPayment, YooKassaPaymentWithEmail };
